import React from 'react';

export default function GradientButton({ children, variant = 'primary', className = '', onClick, disabled, type = 'button', ...props }) {
  const base = 'inline-flex items-center justify-center gap-2 font-medium transition-all duration-300 rounded-xl text-sm';
  const variants = {
    primary: 'bg-gradient-to-r from-[#00D4FF] to-[#7B61FF] text-white px-8 py-3.5 shadow-[0_0_20px_rgba(0,212,255,0.25)] hover:shadow-[0_0_30px_rgba(0,212,255,0.4)] hover:scale-[1.03] active:scale-[0.98] disabled:opacity-50',
    ghost: 'bg-transparent text-[#F0F0F5] px-8 py-3.5 border border-[rgba(255,255,255,0.12)] hover:bg-[rgba(255,255,255,0.05)] hover:border-[rgba(0,212,255,0.3)] active:scale-[0.98]',
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
